/* eslint-disable react/prop-types */
import React from 'react';
import { _RoundedBox } from "../../style/CommonStyles";
import { _DiscountedPrice } from "../styles";
var DiscountedPrice = function DiscountedPrice(_ref) {
  var charge = _ref.charge,
    chargeTitleTip = _ref.chargeTitleTip;
  return /*#__PURE__*/React.createElement(_RoundedBox, {
    "data-tip": chargeTitleTip,
    canceled: charge.canceled,
    refunded: charge.refunded
  }, /*#__PURE__*/React.createElement(_DiscountedPrice, {
    canceled: charge.canceled || charge.refunded
  }, /*#__PURE__*/React.createElement("span", null, "$", charge.original_price), /*#__PURE__*/React.createElement("span", null, "$", charge.price)));
};
export default DiscountedPrice;